import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Icons } from "../../assest/icons";
import { toast } from "react-toastify";
import LeftSideLogin from "../leftsidelogin";
import { logger } from '../../utils/logger';
import { fetchWithAppCheck } from '../../utils/fetchWithAppCheck';


function AdminForgotPassword() {

  const [ShowLoader, setShowLoader] = useState(false);
  const [firstStep, setFirstStep] = useState(true);
  const [finalStep, setFinalStep] = useState(false);

  const [email, setEmail] = useState('');
  const [errors, setErrors] = useState({});

  const handleEmailChange = (event) => {
    const { value } = event.target;
    setEmail(value);
    setErrors('');
  };

  const handleResetFormStart = () => {
    setEmail('');
    setErrors('');
  };

  const isValidEmail = (emailValue) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(emailValue);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    let formErrors = {};
    if (!email.trim()) {
      formErrors.email = 'Please enter your email';
    } else if (!isValidEmail(email)) {
      formErrors.email = 'Please enter a valid email address';
    }
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setShowLoader(true);

    try {
      const functionsBase = process.env.REACT_APP_FUNCTIONS_BASE_URL
        || 'https://us-central1-aigicare-prod.cloudfunctions.net';

      // Server-side: token generation, Firestore write, email send, rate-limiting, audit log
      const resetRes = await fetchWithAppCheck(`${functionsBase}/requestAdminPasswordReset`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email: email.trim().toLowerCase() }),
      });
      const resetData = await resetRes.json();

      if (resetRes.status === 429) {
        throw new Error(resetData.message || 'Too many reset requests. Please try again later.');
      }

      if (!resetRes.ok) {
        throw new Error(resetData.message || 'An error occurred. Please try again later.');
      }

      // Always show generic message (HIPAA — never reveal whether email exists)
      toast.success("If an account exists, a password reset link has been sent.", {
        position: toast.POSITION.TOP_RIGHT,
      });

      setShowLoader(false);
      setFirstStep(false);
      setFinalStep(true);
      handleResetFormStart();

    } catch (error) {
      logger.error('Error sending admin password reset email:', error);
      const safeMsg = error.message && error.message.includes('Too many reset requests')
        ? error.message
        : 'An error occurred. Please try again later.';
      toast.error(safeMsg, {
        position: toast.POSITION.TOP_RIGHT,
      });
      setShowLoader(false);
    }
  };

  return (
    <div>
      <div className='container-fluid p-0 bgImageUrl'>
        <div className='container p-0 contentBody loginScreen'>

          <LeftSideLogin />

          <div className="col-lg-5 d-inline-block position-relative">
            <div className="loginBoxDiv">

              <div className={"singUpFirstStep " + (firstStep ? "" : "d-none")}>
                <h3 className="titleDespTxt">Forgot Password?</h3>
                <p>Enter your admin email address and we'll send you a link to reset your password.</p>
                <form onSubmit={handleSubmit} autoComplete="off">

                  <div className='inputGroupDiv mt-5'>
                    <label><b>Enter your email address below</b></label>
                    <div className="inputTxtBox registerInputDiv mt-2">
                      <img src={Icons[0].mailImg} className="logoImg" alt="" />
                      <input
                        type="text"
                        value={email}
                        placeholder="Admin email id"
                        autoComplete="off"
                        onChange={handleEmailChange}
                      />
                    </div>
                    {errors.email && <span className="errorTxt">{errors.email}</span>}
                  </div>

                  {ShowLoader ? (
                    <button className="signInBtn">
                      Loading
                      <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </button>
                  ) : (
                    <button className="signInBtn" type="submit">Send password reset link</button>
                  )}

                  <div className="signupDiv">
                    <Link to="/admin">Back to login</Link>
                  </div>
                </form>
              </div>

              <div className={"singUpFinalStep " + (finalStep ? "" : "d-none")}>
                <span className="emailVerificationDiv">
                  <img src={Icons[0].checkedIcon} className="logoImg" alt="" />
                  <h3>Check Your Email</h3>
                  <p>We sent a password reset link to your email address. Check your inbox for further instructions.</p>
                  <Link to="/admin">
                    <button className="signInBtn mb-0">Back to login</button>
                  </Link>
                  <span style={{ display: "block", marginTop: "40px" }}>
                    Didn't receive the email?{" "}
                    <a className="linkBlueTxt" href="/admin/forgotpassword">Click here to resend.</a>
                  </span>
                </span>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default AdminForgotPassword;
